import classNames from "classnames";
import {
  ChangeEvent,
  HTMLInputTypeAttribute,
  PropsWithChildren,
  ReactNode,
} from "react";

const Input = ({
  label,
  type,
  name,
  error,
  onChange,
  value,
  disabled = false,
  placeholder,
  required = false,
  className,
  rightIcon,
  onBlur,
  id,
  min = 0,
  max = 0,
}: {
  name: string;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  label: string;
  type?: HTMLInputTypeAttribute;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  className?: string;
  rightIcon?: (className: string) => ReactNode;
  onBlur?: React.EventHandler<any>;
  id?: string;
  min?: number;
  max?: number;
}) => {
  return (
    <ElementWithWrapper
      name={name}
      label={label}
      error={error}
      required={required}
      className={className}
    >
      <InputElement
        type={type}
        className="h-[46px] w-full px-[20px] rounded-[5px] border-[1px] border-lightGrey"
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        name={name}
        rightIcon={rightIcon}
        onBlur={onBlur}
        id={id}
        min={min}
        max={max}
      />
    </ElementWithWrapper>
  );
};

export default Input;

export const InputElement = ({
  type,
  name,
  onChange,
  value,
  disabled = false,
  placeholder,
  required = false,
  className,
  icon,
  rightIcon,
  onBlur,
  id,
  min = 0,
  max = 0,
}: {
  name?: string;
  disabled?: boolean;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  className?: string;
  icon?: (className: string) => ReactNode;
  rightIcon?: (className: string) => ReactNode;
  onBlur?: React.EventHandler<any>;
  id?: string;
  min?: number;
  max?: number;
}) => {
  return (
    <div
      className={classNames(
        "flex items-center h-[46px] w-full px-[20px] rounded-[5px] border-[1px] border-lightGrey gap-3 relative",
        { "bg-white-ghost cursor-not-allowed": disabled },
        className
      )}
    >
      {icon?.("")}
      <input
        type={type}
        // className={classNames(
        //   "h-[46px] w-full px-[20px] rounded-[5px] border-[1px] border-lightGrey",
        //   className
        // )}
        className="w-full h-full bg-inherit text-inherit"
        onChange={onChange}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        name={name}
        onBlur={onBlur}
        id={id}
        min={min}
        max={max}
      />
      {rightIcon?.("")}
    </div>
  );
};

export const ElementWithWrapper = ({
  name,
  label,
  children,
  error,
  required = false,
  className,
}: PropsWithChildren<{
  name?: string;
  label: string;
  error?: string;
  required?: boolean;
  className?: string;
}>) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <label
          htmlFor={name}
          className="block text-sm font-semibold leading-6 text-black-raisin"
        >
          {label}
        </label>
        {required && <span className="text-red-american">*</span>}
      </div>
      <div className="mt-2">{children}</div>
      {error && <ErrorMessage text={error} />}
    </div>
  );
};

export const ErrorMessage = ({ text }: { text?: string }) => {
  if (!text) return null;
  return <span className="text-xs text-red-500">{text}</span>;
};
